import { render, staticRenderFns } from "./LotDetailsView.vue?vue&type=template&id=0663738e&scoped=true"
import script from "./LotDetailsView.vue?vue&type=script&lang=ts"
export * from "./LotDetailsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0663738e",
  null
  
)

export default component.exports